import { combineReducers, configureStore } from '@reduxjs/toolkit';

import {READ_ONLY_MODE_LOCKED_EVENT} from "../utils/readOnlyModeEvents";
import { authApi } from './auth/authApi';
import { auth } from './auth/authReducer';
import { dashboardApi } from './dashboard/dashboardApi';
import { documentApi } from './document/documentApi';
import { facultyApi } from './faculty/facultyApi';
import { groupApi } from './group/groupApi';
import {journalApi} from "./journal/journalApi";
import {practiceApi} from "./practice/practiceApi";
import { sessionApi } from './session/sessionApi';
import { statementApi } from './statement/statementApi';
import { studentApi } from './student/studentApi';
import { userApi } from './user/userApi';
import {attestationApi} from "./attestation/attestationApi";
import {courseApi} from "./course/courseApi";
import {employeeApi} from "./employee/employeeApi";
import {chairApi} from "./chair/chairApi";
import {umuApi} from "./umu/umuApi";
import {themePlanApi} from "./themeplan/themePlanApi";
import {virtualGroupApi} from "./virtualgroup/virtualGroupApi";
import {reportsApi} from "./reports/reportsApi";
import {systemApi} from "./system/systemApi";
import {grcApi} from "./grc/grcApi";
import semesterReducer from "./semester/semester-reducer";
import userReducer from "./user/user-reducer";
import {aiApi} from "./ai/aiApi";
import {scheduleApi} from "./schedule/scheduleApi";
import {statementRegistryApi} from "./statementRegistry/statementRegistryApi";
import {assistantApi} from "./assistant/assistantApi";

const readOnlyModeErrorMiddleware = () => (next) => (action) => {
  const result = next(action);

  if (action?.payload?.status === 423 && typeof window !== 'undefined') {
    const message = action.payload.data?.errors?.[0];
    window.dispatchEvent(new CustomEvent(READ_ONLY_MODE_LOCKED_EVENT, {detail: message}));
  }

  return result;
};

const reducer = combineReducers({
  auth: auth.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [attestationApi.reducerPath] : attestationApi.reducer,
  [chairApi.reducerPath] : chairApi.reducer,
  [courseApi.reducerPath] : courseApi.reducer,
  [dashboardApi.reducerPath]: dashboardApi.reducer,
  [documentApi.reducerPath]: documentApi.reducer,
  [employeeApi.reducerPath]: employeeApi.reducer,
  [facultyApi.reducerPath]: facultyApi.reducer,
  [groupApi.reducerPath]: groupApi.reducer,
  [journalApi.reducerPath]: journalApi.reducer,
  [practiceApi.reducerPath]: practiceApi.reducer,
  [sessionApi.reducerPath]: sessionApi.reducer,
  [statementApi.reducerPath]: statementApi.reducer,
  [statementRegistryApi.reducerPath]: statementRegistryApi.reducer,
  [studentApi.reducerPath]: studentApi.reducer,
  [umuApi.reducerPath]: umuApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [reportsApi.reducerPath]: reportsApi.reducer,
  [scheduleApi.reducerPath]: scheduleApi.reducer,
  [systemApi.reducerPath]: systemApi.reducer,
  [aiApi.reducerPath]: aiApi.reducer,
  [assistantApi.reducerPath]: assistantApi.reducer,
  [grcApi.reducerPath]: grcApi.reducer,
  [themePlanApi.reducerPath]: themePlanApi.reducer,
  [virtualGroupApi.reducerPath]: virtualGroupApi.reducer,
  semesterReducer, // Редюсер семестров
  userReducer // Редюсер пользователя
});

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      attestationApi.middleware,
      chairApi.middleware,
      courseApi.middleware,
      dashboardApi.middleware,
      documentApi.middleware,
      employeeApi.middleware,
      facultyApi.middleware,
      groupApi.middleware,
      journalApi.middleware,
      practiceApi.middleware,
      sessionApi.middleware,
      statementApi.middleware,
      statementRegistryApi.middleware,
      studentApi.middleware,
      umuApi.middleware,
      userApi.middleware,
      reportsApi.middleware,
      scheduleApi.middleware,
      systemApi.middleware,
      aiApi.middleware,
      assistantApi.middleware,
      grcApi.middleware, 
      themePlanApi.middleware,
      virtualGroupApi.middleware,
      readOnlyModeErrorMiddleware,
    ),
});
